// extracted by mini-css-extract-plugin
export default {"inputWrapper":"nickname_inputWrapper__aARgD","label":"nickname_label__wGlsL","input":"nickname_input__CC1EJ"};